export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/dialectic_thinking_in_product_design-ffd25862c30db884df1702eb6631b92f.png";